module.exports = __webpack_public_path__ + "static/img/addImg.ff1c562d.jpg";